export default function RenderLogo() {
  return (
    <div className="flex items-center justify-center w-full py-1">
      <img src="/new-logo-aosonline.png" alt="AOS Online" className="h-12 w-auto object-contain block dark:hidden" />
      <img
        src="/new-logodark-aosonline.png"
        alt="AOS Online"
        className="h-12 w-auto object-contain hidden dark:block brightness-0 invert"
      />
    </div>
  );
}
